import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { MatCardSubtitle, MatCardTitle } from '@angular/material/card';
import { NgOptimizedImage } from '@angular/common';
import { RouterLink } from '@angular/router';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dialog-home-tutorial',
  standalone: true,
  imports: [
    MatDialogActions,
    MatDialogContent,
    MatButton,
    MatDialogClose,
    MatCardTitle,
    MatCardSubtitle,
    NgOptimizedImage,
    RouterLink,
  ],
  templateUrl: './dialog-home-tutorial.component.html',
  styleUrl: './dialog-home-tutorial.component.scss',
})
export class DialogHomeTutorialComponent {
  constructor(
    private dialogRef: MatDialogRef<DialogHomeTutorialComponent>,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: { simularLink?: string },
  ) {}

  simular(): void {
    let link = this.data.simularLink;
    if (!link) {
      link = '/mapa-orcamento-escola';
    }
    this.dialogRef.close();
    this.router.navigate([link]);
  }
}
